const LOCK_KEY = 'fct-mesa-tab-lock';
const TAB_ID_KEY = 'fct-mesa-tab-id';
const HEARTBEAT_MS = 2000;
const STALE_MS = 10000;

const safeGet = (storage, key) => {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (storage, key, value) => {
  try {
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

const safeRemove = (storage, key) => {
  try {
    storage.removeItem(key);
  } catch {
    // ignore quota / private-mode errors
  }
};

const readLock = () => {
  const raw = safeGet(localStorage, LOCK_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

const getTabId = () => {
  let tabId = safeGet(sessionStorage, TAB_ID_KEY);
  if (!tabId) {
    tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    safeSet(sessionStorage, TAB_ID_KEY, tabId);
  }
  return tabId;
};

const isLockFresh = lock =>
  !!lock && Date.now() - Number(lock.timestamp) < STALE_MS;

let lifecycle = null;

const unbindLifecycle = () => {
  if (!lifecycle) return;

  window.removeEventListener('pagehide', lifecycle.clearLock);
  document.removeEventListener(
    'visibilitychange',
    lifecycle.onVisibilityChange
  );
  window.removeEventListener('pageshow', lifecycle.onPageshow);
  clearInterval(lifecycle.heartbeatId);
  lifecycle = null;
};

const bindLifecycle = handlers => {
  unbindLifecycle();

  window.addEventListener('pagehide', handlers.clearLock);
  document.addEventListener('visibilitychange', handlers.onVisibilityChange);
  window.addEventListener('pageshow', handlers.onPageshow);
  lifecycle = {
    ...handlers,
    heartbeatId: setInterval(handlers.writeLock, HEARTBEAT_MS)
  };
};

export const isMesaOpenInAnotherTab = () => {
  safeRemove(localStorage, 'active');
  safeRemove(localStorage, 'timestamp');

  const tabId = getTabId();
  const claimId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const existing = readLock();
  const anotherTabAlive =
    isLockFresh(existing) && existing.tabId !== tabId;

  if (anotherTabAlive) {
    unbindLifecycle();
    return true;
  }

  const writeLock = () => {
    safeSet(
      localStorage,
      LOCK_KEY,
      JSON.stringify({ tabId, claimId, timestamp: Date.now() })
    );
  };

  const clearLock = () => {
    const lock = readLock();
    if (lock && lock.claimId === claimId) {
      safeRemove(localStorage, LOCK_KEY);
    }
  };

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      writeLock();
    }
  };

  const onPageshow = event => {
    if (!event.persisted) return;
    const lock = readLock();
    if (isLockFresh(lock) && lock.tabId !== tabId) {
      window.location.reload();
      return;
    }
    writeLock();
  };

  writeLock();
  bindLifecycle({
    clearLock,
    onVisibilityChange,
    onPageshow,
    writeLock
  });

  return false;
};
